import { useSession } from '~/contexts/SessionContext';
import { RoiService } from '~/domain/services/structureSet/RoiService';

export function useRoiService(): RoiService {
    return useSession().roiService;
}
